import AjaxService from "../../platform/ajax/AjaxService";

export async function deleteAllMechanicalData() {
    await AjaxService.delete("/api/delete-mechanical-data");
}
